import { login, logout, refreshToken } from '@/service/login'
import { getToken, setToken, setExpiresIn, removeToken } from '@/utils/auth'
import localCache from '@/utils/cache'
interface UserState {
  token: string;
  expires_in?: number;
  id: string;
  name: string;
  avatar: string;
  roles: string[];
  permissions: string[];
}

const user = {
  namespaced: true,
  state: {
    token: localCache.getCache('token'),
    id: '',
    name: '',
    avatar: '',
    roles: [],
    permissions: []
  } as UserState,

  mutations: {
    SET_TOKEN: (state: UserState, token: string) => {
      state.token = token
    },
    SET_EXPIRES_IN: (state: UserState, time: number) => {
      state.expires_in = time
    },
    SET_ID: (state: UserState, id: string) => {
      state.id = id
    },
    SET_NAME: (state: UserState, name: string) => {
      state.name = name
    },
    SET_AVATAR: (state: UserState, avatar: string) => {
      state.avatar = avatar
    },
    SET_ROLES: (state: UserState, roles: string[]) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state: UserState, permissions: string[]) => {
      state.permissions = permissions
    }
  },

  actions: {
    // 登录
    Login({ commit }: { commit: any }, userInfo: { username: string; password: string; code: string; uuid: string }) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise<void>((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          const data = res.data
          setToken(data.access_token)
          commit('SET_TOKEN', data.access_token)
          setExpiresIn(data.expires_in)
          commit('SET_EXPIRES_IN', data.expires_in)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    

    // 刷新token
    RefreshToken({commit, state}: {commit: any, state: UserState}) {
      return new Promise<void>((resolve, reject) => {
        refreshToken(state.token).then(res => {
          setExpiresIn(res.data)
          commit('SET_EXPIRES_IN', res.data)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    
    // 退出系统
    LogOut({ commit, state }: {commit: any, state: UserState}) {
      return new Promise<void>((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken()
          localCache.clearCache()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }: {commit: any}) {
      return new Promise<void>(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user 